import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudMenuModule, FreudTooltipModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayComponentModule } from 'shared/components/overlay/overlay.module';

import { FaqMenuComponent } from './faq-menu.component';

@NgModule({
	declarations: [FaqMenuComponent],
	imports: [
		CommonModule,
		FreudTooltipModule,
		FreudMenuModule,
		TranslateModule,
		OverlayComponentModule,
	],
	exports: [FaqMenuComponent],
})
export class FaqMenuModule {}
